var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center",class:{'wide': _vm.wide !== undefined && _vm.wide !== false}},[_c('v-progress-circular',_vm._b({},'v-progress-circular',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }